export default "__VITE_ASSET__WinIfSvm__"